<template>
  <div class="Register">
    <h1>用户注册</h1>
    <div class="container">
      <div class="Steps">
        <div>
          <img style="margin-top: 1rem" src="../assets/images/形状 4.png" alt />
        </div>
        <div class="middle"></div>
        <div class="First" :class="active == 1 ? 'active2' : ''">
          <!-- <img v-show="active == 1" src="../assets/images/形状 4.png" alt="" /> -->
          <!-- v-show="active == 0" -->
          <span>2</span>
        </div>
      </div>
      <el-row type="flex" justify="space-between">
        <span style="margin-left: 0.5rem">注册</span>
        <span
          style="margin-right: -0.5rem"
          :class="active == 0 ? 'isFirst' : ''"
          >完善信息</span
        >
      </el-row>

      <template v-if="active === 0">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="ruleForm"
          class="Form"
          label-width="80px"
        >
          <!-- <el-form-item label="注册类型:">
            <el-radio class="elrado" v-model="Type" label="0">机构</el-radio>
          </el-form-item> -->
          <el-form-item label="用户名:" prop="user">
            <el-input
              placeholder="请输入用户名,只允许输入字母或者数字"
              v-model="ruleForm.user"
              @input="onInputDown"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="pass">
            <el-input
              placeholder="请输入密码"
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="重复密码:" prop="checkPass">
            <el-input
              placeholder="请输入重复密码"
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item label="邮箱:" prop="email">
            <el-input
              placeholder="请输入邮箱"
              v-model="ruleForm.email"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="phone">
            <el-input
              placeholder="请输入手机号"
              v-model="ruleForm.phone"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码:" prop="input3">
            <el-input
              placeholder="请输入验证码"
              v-model="ruleForm.input3"
              class="input-with-select"
            >
              <el-button
                slot="append"
                @click="sendYzM"
                type="primary"
                plain
                :disabled="IsRegister"
                class="elmat"
              >
                <span v-show="!CountDown" style="color: 2769DC"
                  >发送验证码</span
                >
                <span v-show="CountDown" style="color: 2769DC"
                  >{{ CountNum }}秒后可重发</span
                >
              </el-button>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              class="submitBtn"
              @click="NextForm('ruleForm')"
              type="primary"
              >下一步</el-button
            >
          </el-form-item>
        </el-form>
      </template>
      <template v-else>
        <el-form
          ref="ruleForms"
          :rules="rules1"
          :model="ruleForms"
          class="Form"
          label-width="100px"
        >
          <el-form-item label="姓名:" prop="name">
            <el-input
              v-model="ruleForms.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别:">
            <el-radio class="lanv" v-model="ruleForms.sex" :label="0"
              >男</el-radio
            >
            <el-radio class="lanv" v-model="ruleForms.sex" :label="1"
              >女</el-radio
            >
          </el-form-item>
          <el-form-item label="职务:" prop="post">
            <el-input
              v-model="ruleForms.post"
              placeholder="请输入职务"
            ></el-input>
          </el-form-item>
          <el-form-item label="机构名称:" prop="CorporateName">
            <el-input
              v-model="ruleForms.CorporateName"
              @blur="corporateNameChange"
              placeholder="请输入机构名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号级别:" prop="level">
            <el-select v-model="ruleForms.level" placeholder="请选择账号级别" style="width: 25rem;">
              <el-option
                v-for="(role,index) in roles"
                :label="role.RoleName"
                :value="role.ID"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="机构地址:" prop="Address">
            <el-input
              v-model="ruleForms.Address"
              placeholder="请输入机构地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式:" prop="Tel">
            <el-input
              v-model="ruleForms.Tel"
              @input="InputTel"
              placeholder="请输入机构联系方式"
            ></el-input>
          </el-form-item>
          <el-form-item label="机构类型:" prop="OrganizationType">
            <el-radio-group v-model="ruleForms.OrganizationType">
              <el-radio
                class="JgTypeItem"
                v-for="(i, n) in organTypeList"
                :key="n"
                :label="i.remark"
                >{{ i.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="所属领域:"
            prop="TechFields"
            style="width: 500px"
          >
            <el-checkbox-group v-model="ruleForms.TechFields">
              <el-checkbox
                class="TechItem"
                v-for="(i, n) in TechFieldList"
                :key="n"
                :label="i.Title"
                :value="i.ID"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="区域:" prop="Province">
            <el-select
              v-model="ruleForms.Province"
              filterable
              @change="ProvinceChange"
              placeholder="请选择省"
            >
              <el-option
                v-for="item in Province"
                :key="item.ProvinceID"
                :label="item.Name"
                :value="item.ProvinceID"
              ></el-option>
            </el-select>
            <el-select
              v-model="ruleForms.city"
              @change="CityChange"
              placeholder="请选择市"
            >
              <el-option
                v-for="item in city"
                :key="item.CityId"
                :label="item.Name"
                :value="item.CityId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属上级单位:" prop="Unit">
            <el-select
              v-model="ruleForms.Unit"
              @change="UnitChange"
              placeholder
              filterable
            >
              <el-option
                v-for="item in FirstUnit"
                :key="item.ID"
                :label="item.RoleName"
                :value="item.ID"
              ></el-option>
            </el-select>
            <!-- <el-select
              filterable
              v-show="ruleForms.Unit == 1184 || ruleForms.Unit == 3177"
              v-model="ruleForms.Science"
              placeholder="请选择"
            >
              <el-option
                placeholder="请选择二级单位"
                v-for="item in SecondUnit"
                :key="item.ID"
                :label="item.RoleName"
                :value="item.ID"
              ></el-option>
            </el-select> -->
          </el-form-item>

          <div class="warning">
            *【所属上级单位】项可编辑输入关键词，根据关键词对下拉列表进行检索
          </div>
          <el-form-item>
            <el-button
              class="submitBtn"
              type="primary"
              @click="onSubmit('ruleForms')"
              :disabled="subMiting"
              >注册</el-button
            >
            <!-- <el-button @click="NextForm('ruleForm')" type="primary"
              >下一步</el-button
            >-->
          </el-form-item>
        </el-form>
      </template>
    </div>
  </div>
</template>

<script>
import { postAction } from "../api/api";
import { Register, Regist, library, pcapi } from "../api/url";
export default {
  data() {
    //验证用户名
    var validateUser = (rule, value, callback) => {
      //// console.log(value);
      if (!value) {
        return callback(new Error("用户名不能为空"));
      }
      setTimeout(() => {
        if (value.length < 6) {
          callback(new Error("用户名长度为6-12位"));
        } else {
          let data = {
            action: "VerificationName",
            name: value,
          };
          postAction(Regist, this.$qs.stringify(data)).then((res) => {
            if (res == 0) {
              callback(new Error("用户名重复,请重新输入"));
            } else {
              callback();
            }
          });
        }
      }, 500);
    };
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      setTimeout(() => {
        var reg_tel =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
        if (reg_tel.test(value)) {
          let data = {
            action: "VerificationExistsMobile",
            mobile: value,
          };
          postAction(Regist, this.$qs.stringify(data)).then((res) => {
            //// console.log(this);
            if (res == 0) {
              callback(new Error("当前手机号已注册!"));

              this.IsRegister = true;
            } else {
              this.IsRegister = false;
              callback();
            }
          });
        } else {
          callback(new Error("请输入正确的手机号!"));
        }
      }, 100);
    };
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("邮箱地址不能为空"));
      }

      setTimeout(() => {
        // /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.]){1,2}[A-Za-z\d]{2,5}$/g;
        // var reg_tel =
        //   /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.]){1,2}[A-Za-z\d]{2,5}$/g; //邮箱验证
        var regTel =
          /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.]){1,2}[A-Za-z\d]{2,5}$/g;
        if (regTel.test(value)) {
          let data = {
            action: "VerificationEmail",
            email: value,
          };
          postAction(Regist, this.$qs.stringify(data)).then((res) => {
            //// console.log(this);
            if (res == 0) {
              callback(new Error("当前邮箱已注册!"));
            } else {
              callback();
            }
          });
        } else {
          callback(new Error("请输入正确的邮箱!"));
        }
      }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var UnitValidate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择一级单位"));
      } else {
        callback();
      }
    };
    return {
      active: 0,
      Type: "0",
      input3: "",
      subMiting: false,
      passwordRegChess: "",
      ruleForm: {
        pass: "",
        checkPass: "",
        email: "",
        user: "",
        phone: "",
        input3: "",
      },
      ruleForms: {
        passwordReg: "",
        user: "",
        type: "0",
        Province: "河南",
        city: "郑州",
        Provinces: "15",
        citys: "70",
        Address: "",
        OrganizationType: "",
        CorporateName: "",
        sex: 0,
        TechFields: [],
        name: "",
        TechField: "",
        Unit: "",
        Science: "",
        email: "",
        level: "",
        Tel: "",
        phone: "",
        SeoKeywords: "",
        SeoTitle: "",
      },
      Province: [],
      city: [],
      TechFieldList: [],
      FirstUnit: [],
      SecondUnit: [],
      organTypeList: [
        {
          remark: "1",
          name: "企业",
        },
        {
          remark: "1203",
          name: "事业单位",
        },
        {
          remark: "2",
          name: "大专院校",
        },
        {
          remark: "3",
          name: "科研院所",
        },
        {
          remark: "1204",
          name: "政府机关",
        },
        {
          remark: "4",
          name: "涉外机构",
        },
        {
          remark: "5",
          name: "其他",
        },
      ],
      nums: "",
      CountDown: false,
      CountNum: 60,
      Count: {},
      IsRegister: true,
      rules: {
        input3: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        user: [{ validator: validateUser, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        phone: [{ validator: checkPhone, trigger: "blur" }],
        email: [{ validator: checkEmail, trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        post: [{ required: true, message: "请输入职务", trigger: "blur" }],
        CorporateName: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        Address: [{ required: true, message: "请输入地址", trigger: "blur" }],

        Tel: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        Unit: [{ validator: UnitValidate, trigger: "blur" }],
        OrganizationType: [
          { required: true, message: "请选择机构类型", trigger: "change" },
        ],
        TechFields: [
          { required: true, message: "请选择所属领域", trigger: "change" },
        ],
      },
      rules1: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        // level: [{ required: true, message: "请选择机构级别", trigger: "blur" }],
        post: [{ required: true, message: "请输入职务", trigger: "blur" }],
        CorporateName: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        Address: [{ required: true, message: "请输入地址", trigger: "blur" }],

        Tel: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        Unit: [{ validator: UnitValidate, trigger: "blur" }],
        OrganizationType: [
          { required: true, message: "请选择机构类型", trigger: "change" },
        ],
        TechFields: [
          { required: true, message: "请选择所属领域", trigger: "change" },
        ],
      },
      roles:[]
    };
  },
  watch: {
    CountNum(val) {
      if (val == 0) {
        clearInterval(this.Count);
        this.CountDown = false;
        this.IsRegister = false;
        this.CountNum = 60;
      }
    },
  },
  created() {
    this.LoadProvince();
    this.loadCity(15);
    this.loadTechfield();
    this.loadUnit(15, 70);
  },
  methods: {
    corporateNameChange() {
      console.log(this.ruleForms.CorporateName);
      let data = {
        action:'GetAccountLevel',
        OrganizationName:this.ruleForms.CorporateName,
      }
      postAction(library, this.$qs.stringify(data)).then((res) => {
        console.log(res)
        this.roles = res
      });
    },
    LoadProvince() {
      let data = {
        action: "Get_Province",
      };
      postAction(pcapi, this.$qs.stringify(data)).then((res) => {
        this.Province = res;
        //// console.log('Get_Province',res)
      });
    },
    loadCity(val) {
      // console.log('城市的省',val)
      let data = {
        action: "Get_City",
        ProvinceID: val,
      };
      postAction(pcapi, this.$qs.stringify(data)).then((res) => {
        this.city = res;
        this.ruleForms.city = res[0].Name;
        this.loadUnit(res[0].ProvinceID, res[0].CityId);
      });
    },
    ProvinceChange(e) {
      // console.log(this.ruleForms.Province)
      this.ruleForms.Provinces = this.ruleForms.Province;
      this.ruleForms.city = "";
      this.ruleForms.Unit = "";
      this.FirstUnit = [];
      this.loadCity(this.ruleForms.Province);
    },
    CityChange() {
      // this.ruleForms.Unit='';
      // // console.log('this.ruleForms.Provinces',this.ruleForms.Provinces)
      // // console.log('this.ruleForms.city',this.ruleForms.city)
      let numProvinces = Number(this.ruleForms.Provinces);
      this.loadUnit(numProvinces, this.ruleForms.city);
    },
    loadTechfield() {
      let data = {
        action: "GetTechFieldEnum",
      };
      postAction(Register, this.$qs.stringify(data)).then((res) => {
        this.TechFieldList = res;
      });
    },
    loadUnit(i, n) {
      let data = {
        action: "GetUnit",
        place: i + "-" + n,
      };
      postAction(Register, this.$qs.stringify(data)).then((res) => {
        // console.log(res)
        this.FirstUnit = res;
      });
    },
    UnitChange() {
      this.loadSecondUnit(this.ruleForms.Unit);
    },
    loadSecondUnit(val) {
      let data = {
        action: "GetScience",
        ID: val,
      };
      //// console.log("所属上级单位",val)
      postAction(Register, this.$qs.stringify(data)).then((res) => {
        this.SecondUnit = res;
      });
    },
    onInputDown() {
      //////// console.log(this.firstForm.user)
      this.ruleForm.user = this.ruleForm.user.replace(/[^\w\.\/]/gi, "");
      this.ruleForm.user = this.ruleForm.user.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
        ""
      );
      this.$forceUpdate();
    },
    InputTel() {
      this.ruleForms.Tel = this.ruleForms.Tel.replace(/[^\w\.\/]/gi, "");
      this.$forceUpdate();
    },

    sendYzM() {
      let data = {
        action: "Get_Code",
        Code: this.getRandomNum(),
        phoNum: this.ruleForm.phone,
      };
      postAction(library, this.$qs.stringify(data)).then((res) => {
        //// console.log(res);
        if (res.code == 0) {
          this.$message({
            showClose: false,
            message: "发送成功,请注意查收",
            type: "success",
          });
          this.CountDown = true;
          this.IsRegister = true;
          this.BeginCount();
        }
      });
    },
    BeginCount() {
      this.Count = setInterval(() => {
        this.CountNum--;
      }, 1000);
    },
    NextForm(FormName) {
      this.$refs[FormName].validate((valid) => {
        this.IsRegister = true;
        if (valid) {
          let Datas = {
            action: "Check_Code",
            CheckCode: this.input3,
          };
          //// console.log(Datas)
          postAction(library, this.$qs.stringify(Datas)).then((res) => {
            //// console.log(res);
            if (res == 0) {
              this.active = 1;
            } else {
              this.$message.error("验证码错误，请重新获取!");
              return false;
            }
          });
        } else {
          return false;
        }
      });
    },
    onSubmit(FormName) {
      this.$refs[FormName].validate((valid) => {
        if (valid) {
          if (this.ruleForms.Unit == "") {
            this.$message.warning("请选择一级单位！");
            return false;
          }
          // if (this.ruleForms.Unit == 1184 || this.ruleForms.Unit == 3177) {
          //   if(this.ruleForms.Science =='')
          //   {
          //     this.$message.warning('请选择二级单位！')
          //     return false
          //   }
          // }
          if (this.ruleForms.name == "") {
            this.$message.warning("请输入姓名！");
            return false;
          }
          this.subMiting = true;
          // //// console.log(this.ruleForm.delete(this.ruleForm.checkPass));
          this.ruleForms.user = this.ruleForm.user;
          this.ruleForms.passwordReg = this.ruleForm.pass;
          this.ruleForms.email = this.ruleForm.email;
          this.ruleForms.phone = this.ruleForm.phone;
      
          let val = JSON.stringify(this.ruleForms.TechField);
          this.ruleForms.TechField = JSON.parse(val);
          // if (this.ruleForms.Science) {
          //   this.ruleForms.Unit = "";
          // }
          let TechId = "";
          this.TechFieldList.forEach((item) => {
            this.ruleForms.TechFields.forEach((items) => {
              if (items == item.Title) {
                TechId += item.ID + "|";
              }
            });
          });
          this.ruleForms.TechField = "|" + TechId;
          setTimeout(() => {
            if (this.ruleForms.Unit == "河南省科学技术厅") {
              //// console.log("没触发")
              this.ruleForms.Unit = 3197;
              //// console.log("没触发hou",this.ruleForms.Unit)
            }
            if (this.ruleForms.Province == "河南") {
              this.ruleForms.Province = 15;
            }
            if (this.ruleForms.city) {
              this.ruleForms.city = 70;
            }
            let data = {
              action: "Regist",
              json: JSON.stringify(this.ruleForms),
            };
            postAction(Register, this.$qs.stringify(data)).then((res) => {
              //// console.log(res);
              if (res.UserID) {
                this.$message({
                  showClose: false,
                  message: "注册成功",
                  type: "success",
                });
                this.$router.push("/");
              }
              this.subMiting = false;
              // if (res.code == 0) {
              // } else {
              //   this.$message.error("验证码错误，请重新获取!");
              //   return false;
              // }
            });
          }, 500);
        }
      });
    },
    // 获取验证码
    getRandomNum() {
      let vm = this;
      this.nums = "";
      for (var i = 0; i < 6; i++) {
        var random = Math.floor(Math.random() * 10);
        this.nums += random;
      }
      return this.nums;
      
      //////// console.log('自动生成随机数', vm.randomNum);
    },
  },
};
</script>

<style lang='scss' scoped>
.Register {
  margin-top: -16.125rem;
  position: absolute;
  left: 0;
  right: 0;
  h1 {
    margin-bottom: 3.25rem;
  }
}
.container {
  width: 87.5rem;
  height: 100%;
  background: #ffffff;
  margin: 0 auto;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.75rem;
  overflow: hidden;
}
h1 {
  font-size: 2.625rem;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 2.9375rem;
  color: #ffffff;
  margin: 0;
}
.el-row {
  width: 40.625rem;
  margin: 0 auto;
  color: #2769dc;
  font-size: 1rem;
  font-family: Microsoft YaHei;
}
.Steps {
  width: 40.625rem;
  height: 5.25rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    width: 3rem;
    height: 3rem;
    background: #2769dc;
    border-radius: 50%;
    line-height: 3.1875rem;
  }
  .middle {
    width: 34.6875rem;
    height: 0.75rem;
    background: #e1e9f6;
    border-radius: 0;
  }
  .First {
    background: #97c3ff;
    font-size: 1.25rem;
    font-family: Microsoft YaHei;
    color: #fff;
  }
}
.isFirst {
  color: #85b8fd;
}
.Form {
  width: 31.25rem;
  margin: 3.9375rem auto 0;
  text-align: left;
}

.active2 {
  background: #2769dc !important;
  img {
    margin-top: 0.75rem;
  }
}
/deep/.el-select {
  width: 9.375rem;
  margin-right: 1.25rem;
}
/deep/.el-form-item__label::before {
  display: none;
}
.submitBtn {
  width: 23.5625rem;
  height: 3.125rem;
  background: #2769dc;
  opacity: 1;
  border-radius: 0.25rem;
}
.warning {
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  width: 40.0625rem;
  height: 3.625rem;
  background: #fff6f6;
  color: #f24949;
  line-height: 3.625rem;
  margin-bottom: 3.125rem;
}
.JgTypeItem {
  width: 5rem;
  margin-top: 0.3125rem;
}
.TechItem {
  width: 8.5rem;
  margin-top: 0.625rem;
  margin-right: 50px;
}
/deep/.el-input-group__append {
  background-color: #fff;
}
/deep/.elmat {
  background: #fff !important;
  color: #2769dc;
  padding: 0.5rem 1rem;
  border: none;
}
/deep/.elrado {
  line-height: 2.7rem;
}
/deep/.el-radio__input {
  margin-top: -0.125rem;
}
/deep/.lanv {
  line-height: 2.9rem;
}
/deep/.el-radio__inner::after {
  background: #fff !important;
}
/deep/.el-button--primary.is-plain:hover {
  color: #2769dc;
}
</style>